import { render, staticRenderFns } from "./Sortby.vue?vue&type=template&id=f64adf80&scoped=true&"
import script from "./Sortby.vue?vue&type=script&lang=js&"
export * from "./Sortby.vue?vue&type=script&lang=js&"
import style0 from "./Sortby.vue?vue&type=style&index=0&id=f64adf80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64adf80",
  null
  
)

export default component.exports